import * as Yup from 'yup'

export const reservationSchema = Yup.object({
  outlet: Yup.string().required('Pilih outlet'),
  outletName: Yup.string().required('Pilih outlet'),
  phone: Yup.string()
    .trim()
    .matches(/^\+?[0-9]{9,15}$/, 'Gunakan 9–15 digit, boleh diawali +')
    .required('No. HP tidak boleh kosong'),
  email: Yup.string().trim().email('Format email tidak valid').required('Email tidak boleh kosong'),
})
